/*
    Merrid Controls. Wszelkie prawa zastrzeżone.
    Plik zawiera kody Źródłowe będące własnością firmy Merrid Controls.
    Nie wolno ich rozpowszechniać w całości lub fragmentach bez wyraźnej zgody właściciela.
*/


import React, {useContext, useEffect, useState} from "react";

import {useDispatch} from "react-redux";
import CHANGE_API_REQUEST_STATUS_ACTION from "@Actions/Interface/ChangeApiRequestStatus";
import {LOG_USER_IN_ACTION} from "@Actions/Authentication";
import {useTypedSelector} from "@Services/Hooks/UseTypedSelector";
import LOGGED_USER_INTERFACE from "@Store/Interfaces/Authentication/User";

import ApplicationApiContext from "@Contexts/Api";


import {Helmet} from "react-helmet";


import {Redirect} from "react-router-dom";


import BlockContentContainerComponent from "@Components/UI/Containers/Block";
import BlockContentHeaderComponent from "@Components/UI/Containers/Block/Header";
import {LoginFormErrorsInterface} from "@UIPages/NotAuthenticated/Login";
import ENV from "react-dotenv";
import validateUserPassword from "@Utilities/Validators/Password";
import PasswordResetStepsComponent from "@UIPages/NotAuthenticated/PasswordReset/Steps";
import internal from "stream";
import {REGISTER_FORM_STEP_TYPE} from "@UIPages/NotAuthenticated/Register";
import ApplicationHeaderComponent from "@UIParts/Header";
import {Col} from "react-bootstrap";
import BlockContentPictureComponent from "@Components/UI/Containers/Block/Picture";
import CHANGE_MODAL_MESSAGE_ACTION from "@Actions/Interface/ChangeModalMessage";


interface PasswordResetFormFieldsInterface {
    formUserLogin?: string;
    formUserPIN?: string;
    formUserOperationGuid?: string,
    formUserSmsCodeValidDate?: string,
    formUserSmsCode?: string;
    formUserId?: string;
    formUserNewPassword?: string;
    formUserNewPasswordRepeat?: string;
}

const PasswordResetFormFields: PasswordResetFormFieldsInterface = {
    formUserLogin: "",
    formUserPIN: "",
    formUserOperationGuid: "",
    formUserSmsCodeValidDate: "",
    formUserSmsCode: "",
    formUserId: "",
    formUserNewPassword: "",
    formUserNewPasswordRepeat: ""
};

export interface PasswordResetErrorsInterface {
    passwordResetProcess?: string | null;
    formUserLogin?: string | null;
    formUserPIN?: string | null;
    formUserSmsCode?: string | null;
    formUserNewPassword?: string | null;
    formUserNewPasswordRepeat?: string | null;
}


export type PasswordResetFormStepType = 1 | 2 | 3 | 4;


type PasswordResetPageComponentProps = {};


export const PasswordResetPageComponent: React.FC<PasswordResetPageComponentProps> = ({}): JSX.Element | null => {


    /** @type {UserInterface | null} Application Logged User (from Global Store Object */
    const LOGGED_USER: LOGGED_USER_INTERFACE = useTypedSelector(
        (state):ReturnType<any> => state?.authentication
    )?.loggedUser || null;


    /** @var {DISPATCHER} Global State Actions Dispatcher */
    const DISPATCHER = useDispatch();


    /** @var {REST_API_URL} Global Rest Api Root URL Address */
    const REST_API_URL = useContext(ApplicationApiContext)?.API_ROOT_URL;


    /** @var {APP_NAME} Application Name - Environment Variable */
    const {APP_NAME} = ENV || {};


    /** @var {STORED_PASSWORD_RESET_FORM_DATA} Stored in local storage Password Reset Form Data */
    const STORED_PASSWORD_RESET_FORM_DATA = localStorage.getItem(`${APP_NAME}_PASSWORD_RESET_FORM_DATA`);
    /** @var {PASSWORD_RESET_FORM_DATA} Parsed stored Password Reset Form Data */
    const PASSWORD_RESET_FORM_DATA = STORED_PASSWORD_RESET_FORM_DATA ? JSON.parse(STORED_PASSWORD_RESET_FORM_DATA) : PasswordResetFormFields;

    const {
        formUserLogin: formUserLoginDefault, formUserPIN: formUserPINDefault,
        formUserOperationGuid: formUserOperationGuidDefault, formUserSmsCodeValidDate: formUserSmsCodeValidDateDefault,
        formUserSmsCode: formUserSmsCodeDefault, formUserId: formUserIdDefault,
        formUserNewPassword: formUserNewPasswordDefault, formUserNewPasswordRepeat: formUserNewPasswordRepeatDefault
    } = PasswordResetFormFields;


    const [passwordResetSubmitSuccessStatus, setPasswordResetSubmitSuccessStatus] = useState<boolean>(false);

    const [passwordResetFormErrors, setPasswordResetErrors] = useState<PasswordResetErrorsInterface>({});
    const [passwordResetFormStep, setPasswordResetFormStep] = useState<PasswordResetFormStepType>(1);

    const [formUserLogin, setFormUserLogin] = useState<string>("");
    const [formUserPIN, setFormUserPIN] = useState<string>("");

    const [formUserOperationGuid, setFormUserOperationGuid] = useState<string>("");
    const [formUserSmsCodeValidDate, setFormUserSmsCodeValidDate] = useState<string>("");
    const [formUserSmsCode, setFormUserSmsCode] = useState<string>("");

    const [formUserId, setFormUserId] = useState<string>("");

    const [formUserNewPassword, setFormUserNewPassword] = useState<string>("");
    const [formUserNewPasswordRepeat, setFormUserNewPasswordRepeat] = useState<string>("");


    /**
     * @Hooks - Did Mount (after first Render)
     * Set Active Register form Step
     */
    useEffect(() => {
        let passwordResetFormStep: PasswordResetFormStepType = 1;
        if (formUserOperationGuid) passwordResetFormStep = 2;
        if (formUserId) passwordResetFormStep = 3;
        setPasswordResetFormStep(passwordResetFormStep);
    }, []);


    const changeFormUserLogin = (e: React.ChangeEvent<HTMLInputElement>): void => {
        if (passwordResetFormStep !== 1) return; // if step != 1 do nothing
        /** @var {} */
        const userLogin: string = e.target.value;
        if (userLogin.length > 2) setPasswordResetErrors({...passwordResetFormErrors, formUserLogin: null});
        setFormUserLogin(userLogin);
    };

    const changeFormUserPIN = (e: React.ChangeEvent<HTMLInputElement>): void => {
        if (passwordResetFormStep !== 1) return;
        const userPIN = e.target.value;
        // if (userPIN.length > 4) return;
        // if (userPIN.length === 4 && !isNaN(+formUserPIN)) setPasswordResetErrors({...passwordResetFormErrors, formUserPIN: null});
        setFormUserPIN(userPIN);
    };

    const changeFormUserSmsCode = (e: React.ChangeEvent<HTMLInputElement> | string): void => {
        if (passwordResetFormStep !== 2) return;
        const userSMSCode = typeof e === "string" ? e : e.target.value;
        if (userSMSCode.length > 6) return;
        if (userSMSCode.length === 6) setPasswordResetErrors({...passwordResetFormErrors, formUserSmsCode: null});
        setFormUserSmsCode(userSMSCode);
    };

    const changeFormUserNewPassword = (e: React.ChangeEvent<HTMLInputElement>): void => {
        if (passwordResetFormStep !== 3) return;
        const userPassword = e.target.value;
        if (validateUserPassword(userPassword)) setPasswordResetErrors({...passwordResetFormErrors, formUserNewPassword: null});
        setFormUserNewPassword(userPassword);
    };

    const changeFormUserNewPasswordRepeat = (e: React.ChangeEvent<HTMLInputElement>): void => {
        if (passwordResetFormStep !== 3) return;
        const userPasswordRepeat = e.target.value;
        if (userPasswordRepeat === formUserNewPassword  ) setPasswordResetErrors({...passwordResetFormErrors, formUserNewPasswordRepeat: null});
        setFormUserNewPasswordRepeat(userPasswordRepeat);
    };


    const storePasswordResetFormData = (updatedFields?: PasswordResetFormFieldsInterface) => {

        const PASSWORD_RESET_FORM_DATA = {
            formUserLogin, formUserPIN,
            formUserOperationGuid, formUserSmsCodeValidDate, formUserSmsCode,
            formUserId
        };

        const STORE_FORM_DATA = {...PASSWORD_RESET_FORM_DATA, ...updatedFields};
        localStorage.setItem(`${APP_NAME}_PASSWORD_RESET_FORM_DATA`, JSON.stringify(STORE_FORM_DATA));

    };


    const resetPasswordResetFormHandler = () => {

        setFormUserLogin("");
        setFormUserPIN("");

        setFormUserOperationGuid("");
        setFormUserSmsCodeValidDate("");
        setFormUserSmsCode("");

        setFormUserId("");

        setFormUserNewPassword("");
        setFormUserNewPasswordRepeat("");

        setPasswordResetErrors({});
        setPasswordResetFormStep(1);

        setPasswordResetSubmitSuccessStatus(false);

        localStorage.removeItem(`${APP_NAME}_PASSWORD_RESET_FORM_DATA`);

    };


    const [enterKeyPressCount, setEnterKeyPressCount] = useState<number>(0);

    useEffect(() => {
        let n = 0;
        const HANDLER = (e: KeyboardEvent) => {
            if (e.key === "Enter") setEnterKeyPressCount(++n);
        }
        document.addEventListener("keydown", HANDLER);
        return () => document.removeEventListener("keydown", HANDLER);
    }, []);

    useEffect(() => {
        if (enterKeyPressCount === 0) return;
        let newPasswordResetFormStep: PasswordResetFormStepType = passwordResetFormStep;
        if (passwordResetFormStep === 1) newPasswordResetFormStep = 2;
        if (passwordResetFormStep === 2) newPasswordResetFormStep = 3;
        if (passwordResetFormStep === 3) newPasswordResetFormStep = 4;
        changePasswordResetStepHandler(newPasswordResetFormStep);
    }, [enterKeyPressCount]);


    if (LOGGED_USER && LOGGED_USER?.userID) return <Redirect to={"/"} />;


    if (passwordResetFormStep > 3) return null;


    const changePasswordResetStepHandler = async (step: PasswordResetFormStepType): Promise<void | null> => {

        let formError;

        switch (passwordResetFormStep) {
            case 1:
                formError = !validatePasswordResetFormStep1();
                break;
            case 2:
                formError = !validatePasswordResetFormStep2();
                break;
            case 3:
                formError = !validatePasswordResetFormStep3();
                break;
            default:
                formError = true;
        }

        if (formError) return null;

        const passwordResetRequestStatus = await passwordResetFormRequestHandler(step);

        if (!passwordResetRequestStatus) return null;

        setPasswordResetFormStep(step);

    };


    const validatePasswordResetFormStep1 = () => {

        const formErrors: PasswordResetErrorsInterface = {};

        //if (formUserLogin.length < 8) formErrors.formUserLogin = "Nazwa użytkownika jest zbyt krótka";
        // if (formUserPIN.length !== 4 || isNaN(+formUserPIN)) formErrors.formUserPIN = "PIN ma nieprawidłowy format";

        setPasswordResetErrors(formErrors);

        return !(Object.entries(formErrors).length > 0);

    };

    const validatePasswordResetFormStep2 = () => {

        const formErrors: PasswordResetErrorsInterface = {};

        // if (formUserSmsCode.length !== 6) formErrors.formUserSmsCode = "Nieprawidłowy kod weryfikacyjny";

        setPasswordResetErrors(formErrors);

        return !(Object.entries(formErrors).length > 0);

    };

    const validatePasswordResetFormStep3 = () => {

        const formErrors: PasswordResetErrorsInterface = {};

        if (!validateUserPassword(formUserNewPassword)) formErrors.formUserNewPassword = "Podane hasło ma nieprawidłowy format";
        if (formUserNewPasswordRepeat !== formUserNewPassword) formErrors.formUserNewPasswordRepeat = "Podane hasła różnią się";

        setPasswordResetErrors(formErrors);

        return !(Object.entries(formErrors).length > 0);

    };


    const passwordResetFormRequestHandler = async (step?: PasswordResetFormStepType): Promise<boolean | null> => {

        if (!REST_API_URL) return false;

        let RESPONSE_STATUS: boolean = false;

        let PASSWORD_RESET_API_URL: string = `${REST_API_URL}/User`;
        let PASSWORD_RESET_FORM_DATA: string;

        switch (passwordResetFormStep) {
            case 1:
                PASSWORD_RESET_API_URL += "/ResetPwd/Initialization";
                PASSWORD_RESET_FORM_DATA = JSON.stringify({Login: formUserLogin, CardPIN: formUserPIN});
                break;
            case 2:
                PASSWORD_RESET_API_URL += "/ResetPwd/Step1";
                PASSWORD_RESET_FORM_DATA = JSON.stringify({Login: formUserLogin, OperationGUID: formUserOperationGuid, VerificationCode: formUserSmsCode});
                break;
            case 3:
                PASSWORD_RESET_API_URL += "/ResetPwd/Finalization";
                PASSWORD_RESET_FORM_DATA = JSON.stringify({UserId: formUserId, OperationGUID: formUserOperationGuid, Password: btoa(formUserNewPassword)});
                break;
            default:
                return false;
        }

        DISPATCHER(CHANGE_API_REQUEST_STATUS_ACTION(true));

        try {

            const RESPONSE = await fetch(PASSWORD_RESET_API_URL, {
                method: "POST",
                headers: {"Content-Type": "application/json"},
                body: PASSWORD_RESET_FORM_DATA
            });

            const RESPONSE_CONTENT: any = RESPONSE.status === 204 ? null : await RESPONSE.json();

            if (RESPONSE.status === 200 || RESPONSE.status === 204) {

                switch (passwordResetFormStep) {
                    case 1:
                        passwordResetFormStep1ResponseHandler(RESPONSE_CONTENT);
                        RESPONSE_STATUS = true;
                        break;
                    case 2:
                        passwordResetFormStep2ResponseHandler(RESPONSE_CONTENT);
                        RESPONSE_STATUS = true;
                        break;
                    case 3:
                        RESPONSE_STATUS = true;
                        passwordResetFormStep3ResponseHandler();
                        break;
                    default:
                        DISPATCHER(CHANGE_API_REQUEST_STATUS_ACTION(false));
                        return false;
                }

            } else {
                setPasswordResetErrors({...passwordResetFormErrors, passwordResetProcess: RESPONSE_CONTENT.UserMessage});
            }

        } catch (e) {
            setPasswordResetErrors({...passwordResetFormErrors, passwordResetProcess: "Błąd połączenia z serwisem - skontaktuj się z CDOK"});
        }

        DISPATCHER(CHANGE_API_REQUEST_STATUS_ACTION(false));

        return RESPONSE_STATUS;

    };


    const passwordResetFormStep1ResponseHandler = (response: any) => {

        const {OperationGUID: operationGuid, VerificationCodeValidDate: smsCodeValidDate} = response;

        setFormUserOperationGuid(operationGuid);
        setFormUserSmsCodeValidDate(smsCodeValidDate);

        storePasswordResetFormData({
            formUserOperationGuid: operationGuid, formUserSmsCodeValidDate: smsCodeValidDate
        });

    };


    const passwordResetFormStep2ResponseHandler = (response: any) => {

        const {UserId: userId} = response;

        setFormUserId(userId);

        storePasswordResetFormData({formUserId: userId});

    };


    const passwordResetFormStep3ResponseHandler = () => {

        DISPATCHER(CHANGE_MODAL_MESSAGE_ACTION(`Hasło zostało zmienione`, "SUCCESS"));

        setPasswordResetSubmitSuccessStatus(true);

    };


    if (passwordResetSubmitSuccessStatus === true) {
        return <Redirect to={"/logowanie"} />;
    }


    return (
        <BlockContentContainerComponent as={"main"} cssClasses={"password-reset-page-component"}>

            <Helmet>
                <title>{`${ENV.APP_TITLE} - Resetowanie Hasła`}</title>
            </Helmet>

            <ApplicationHeaderComponent />

            <Col xs={12} as={"h2"} className={"login-page-header user-form-header"}>
                <span>{`eKiosk - Aplikacja dla Kierowcy`}</span>
            </Col>

            <BlockContentPictureComponent headerPictureType={2} />

            <PasswordResetStepsComponent
                passwordResetFormStep={passwordResetFormStep}
                passwordResetFormStepHandler={changePasswordResetStepHandler}
                passwordResetFormErrors={passwordResetFormErrors}
                formResetHandler={resetPasswordResetFormHandler}
                formUserLogin={formUserLogin}
                formUserLoginHandler={changeFormUserLogin}
                formUserPIN={formUserPIN}
                formUserPINHandler={changeFormUserPIN}
                formUserSmsCode={formUserSmsCode}
                formUserSmsCodeHandler={changeFormUserSmsCode}
                formUserSmsCodeValidDate={formUserSmsCodeValidDate}
                formUserNewPassword={formUserNewPassword}
                formUserNewPasswordHandler={changeFormUserNewPassword}
                formUserNewPasswordRepeat={formUserNewPasswordRepeat}
                formUserNewPasswordRepeatHandler={changeFormUserNewPasswordRepeat}
            />

        </BlockContentContainerComponent>
    )

};


export default PasswordResetPageComponent;
